module.exports = __webpack_public_path__ + "static/media/thumbnail.b5fee7cd.jpg";